export default __webpack_public_path__ + "static/media/KOD0075-min.f6ff5261.webp";